// extracted by mini-css-extract-plugin
module.exports = {"exhibitions":"Exhibitions_exhibitions__luluZ","exhibitionInfo":"Exhibitions_exhibitionInfo__Z5P53","bottom":"Exhibitions_bottom__R7pep","lh17px":"Exhibitions_lh17px__qxT5o"};